import { apiClient } from './client';

export type IndustryStatus = 'ACTIVE' | 'INACTIVE' | 'COMING_SOON' | 'DEPRECATED';

export type TranslationDict = Partial<
  Record<'zh-hans' | 'zh-hant' | 'en' | 'th' | 'id' | 'vi', string>
>;

export interface Industry {
  id: number;
  code: string;
  name: string;
  name_translations?: TranslationDict | string;
  display_name?: string;
  description: string;
  description_translations?: TranslationDict | string;
  display_description?: string;
  status: IndustryStatus;
  icon?: string | null;
  color: string;
  sort?: number;
  user_count: number;
}

export interface IndustryListParams {
  page?: number;
  page_size?: number;
  status?: IndustryStatus;
  search?: string;
}

export interface PaginatedResponse<T> {
  code: number;
  message: string;
  pagination: {
    count: number;
    page: number;
    page_size: number;
    total_pages: number;
    next: string | null;
    previous: string | null;
  };
  results: T[];
  data: T[];
}

/**
 * 行业管理 API.
 *
 * 备注 (2026-05-22):
 *   后端当前以 /api/ccsk/industry/ 暴露列表 + /api/ccsk/industry/{code}/ 暴露详情.
 *   admin/v1 路由前缀仍是计划态, 这里 BASE 留作变量, 后端就绪后改一处即可.
 */
const BASE = '/admin/v1/industries';

export function listIndustries(
  params?: IndustryListParams,
): Promise<PaginatedResponse<Industry>> {
  return apiClient.get(`${BASE}/`, { params });
}

export function getIndustry(id: number | string): Promise<Industry> {
  return apiClient.get(`${BASE}/${id}/`);
}

export function createIndustry(
  payload: Partial<Industry>,
): Promise<Industry> {
  return apiClient.post(`${BASE}/`, payload);
}

export function updateIndustry(
  id: number | string,
  payload: Partial<Industry>,
): Promise<Industry> {
  return apiClient.patch(`${BASE}/${id}/`, payload);
}

export function deleteIndustry(id: number | string): Promise<void> {
  return apiClient.delete(`${BASE}/${id}/`);
}
